import { render, staticRenderFns } from "./ContactSentView.vue?vue&type=template&id=6517dcb6&"
import script from "./ContactSentView.vue?vue&type=script&lang=ts&"
export * from "./ContactSentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports